export default __webpack_public_path__ + "static/media/services_shower.74f76120.svg";